import { html } from 'lit';
import { distributionMetadata, distributionValues } from '../types.js';
import { styleMap } from 'lit/directives/style-map.js';
import { register as _registerElement } from "../../../elements/one-ux-icon/register-element.js";
_registerElement("icon-513d84a20ec0c49540fed550c415a6c3");
type legendItem = {
  entry: distributionMetadata;
  value: number;
  unit?: string;
  percentage?: number;
};
export function DistributionStaticLegend({
  unit,
  metadata,
  values
}: {
  unit?: string;
  metadata: distributionMetadata[];
  values: distributionValues;
}) {
  const getValue = (key: string) => values[key] || 0;
  const {
    includeItems,
    excludeItems
  } = getLegendItems(metadata);
  const total = includeItems.reduce((sum, {
    entry
  }) => sum + getValue(entry.key), 0);
  const showPercentage = total > 0;
  return html`
    <div
      aria-hidden="true"
      style=${styleMap({
    display: 'grid',
    'grid-template-columns': showPercentage ? 'auto 1fr auto auto' : 'auto 1fr auto',
    gap: '0 var(--one-ux-spacing--200)',
    'align-items': 'flex-start',
    'margin-top': 'var(--one-ux-spacing--200)'
  })}
    >
      ${includeItems.map(item => {
    const percentage = showPercentage ? Math.round(100 * item.value / total) : undefined;
    return LegendItem({
      ...item,
      percentage
    });
  })}
      ${excludeItems?.length ? [Separator(), excludeItems?.map(LegendItem)] : null}
    </div>
  `;
  function getLegendItems(metadata: distributionMetadata[]) {
    return metadata.reduce<{
      includeItems: legendItem[];
      excludeItems: legendItem[];
    }>((acc, curr) => {
      const value = getValue(curr.key);
      if (value != null) {
        const entry = {
          entry: curr,
          value,
          unit
        };
        const prop = curr.exclude ? 'excludeItems' : 'includeItems';
        acc[prop].push(entry);
      }
      return acc;
    }, {
      includeItems: [],
      excludeItems: []
    });
  }
}
function LegendItem({
  entry,
  value,
  unit,
  percentage
}: legendItem) {
  return html`
    <icon-513d84a20ec0c49540fed550c415a6c3
      size="100"
      icon=${entry.icon.name}
      set=${entry.icon.set}
      style=${styleMap({
    color: entry.color
  })}
    ></icon-513d84a20ec0c49540fed550c415a6c3>
    <div
      class="one-ux-typography--label-300"
      style="
          margin: 0;
          white-space: normal; 
          overflow-wrap: anywhere; 
          line-height: var(--one-ux-size--icon-100);
          flex-grow: 1;
        "
    >
      ${entry.name}
    </div>
    <div
      class="one-ux-typography--label-variant-300"
      style="
          margin: 0; 
          line-height: var(--one-ux-size--icon-100);
          white-space: nowrap;
          text-align: right;
        "
    >
      ${value} ${unit}
    </div>
    ${percentage === undefined ? null : html`
          <div
            class="one-ux-typography--label-300"
            style="
                margin: 0; 
                line-height: var(--one-ux-size--icon-100);
                white-space: nowrap;
                color: var(--one-ux-palette--brand-neutral-400);
                text-align: right;
              "
          >
            (${percentage}%)
          </div>
        `}
  `;
}
function Separator() {
  return html`<hr
    style="
      grid-column: 1 / -1;
      margin: var(--one-ux-spacing--100) 0;
      border: none;
      border-top: var(--one-ux-border-width--100) solid var(--one-ux-palette--brand-neutral-300);
      width: 100%;
    "
  />`;
}